import slick from 'slick-carousel';

const showMoreBtn = document.querySelector('.show-more-btn');
if(showMoreBtn){
  showMoreBtn.addEventListener('click', function() {
    const hiddenRows = document.querySelectorAll('.pricing-plans__table.conversations tbody tr:nth-child(n+6)');
    hiddenRows.forEach(row => {
      if (row.style.display === 'table-row') {
        row.style.opacity = 0;
        row.style.height = 0;
        setTimeout(() => {
          row.style.display = 'none';
        }, 300);
      } else {
        row.style.display = 'table-row';
        setTimeout(() => {
          row.style.opacity = 1;
          row.style.height = 'auto';
        }, 10);
      }
    });

    this.textContent = this.textContent === 'Ver más detalles ▼' ? 'Ver menos ▲' : 'Ver más detalles ▼';
  });
}


$('.carrouselMarketingTabs').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
